import React, { useEffect, useState } from "react";
import InputRadio from "../../../../components/InputRadio";
import { getIndexFromObjectArray } from "../../../../helpers/helpers";

const MultipleValue = ({param, productParams, setProductParams}) => {
    const [index, setIndex] = useState(null);
    // Duas opções distintas podem ter o mesmo valor calculado — o InputRadio
    // marca "ativo" comparando por value, então rastreamos qual descrição foi
    // de fato escolhida à parte, pra não marcar várias opções ao mesmo tempo
    // (BDM-1020). O que é salvo em productParams continua o valor numérico.
    const [selectedDescription, setSelectedDescription] = useState(null);

    useEffect(() => {
        let toIndex = getIndexFromObjectArray(productParams, 'id', param.id);
        setIndex(toIndex);
    }, [productParams]);

    // Ao abrir um item já existente, deriva a opção ativa a partir do valor
    // salvo (só na primeira vez).
    useEffect(() => {
        if (index === null || selectedDescription !== null || !param.options?.length) return;
        let currentValue = productParams[index]?.value;
        let match = param.options.find(option => option.value === currentValue);
        if (match) setSelectedDescription(match.description);
    }, [index, param.options]);

    const handleParamChange = description => {
        let selectedOption = param.options.find(option => option.description === description);
        if (!selectedOption) return;

        setSelectedDescription(description);
        setProductParams(prev => {
            let toProductParams = [...prev];
            toProductParams[index].value = selectedOption.value;
            return toProductParams;
        });
    }

    return (
        <>
            {index !== null &&
                <>
                    <div className="modal-section-title">
                        <div className="left">
                            <h2>{param.name}</h2>
                        </div>
                    </div>
                    <div className="section">
                        {/* Não usa createOptions aqui: ele deduplica pelo value, e
                            duas opções distintas podem ter o mesmo valor calculado
                            — cada uma precisa continuar aparecendo (BDM-1020). Usa a
                            descrição (única por opção) como value do radio, não o
                            valor calculado, pra marcar só a opção certa como ativa. */}
                        <InputRadio
                            className="four-columns"
                            options={param.options.map(option => ({ label: option.description, value: option.description }))}
                            value={selectedDescription}
                            change={handleParamChange}
                        />
                    </div>
                </>
            }
        </>
    );
}

export default MultipleValue;